import { html } from "htm/preact";
export const UnderlineLink = ({ children, href, className }) => {
  return html`
    <a href="{href}" className="link-underline-parent relative ${className} pb-1">
      ${children}
      <div className="link-underline w-full h-px absolute bottom-0 bg-primary-300">
        <span className="block w-0 h-px bg-black transition-all duration-300 ease-linear"></span>
      </div>
    </a>
  `;
};
